import React, {createContext} from 'react';
import axios from "../utils/axios";
import { cWarn } from '../components/igtm/CustomLogger';

export const BookingConfigContext = createContext();

class BookingConfigContextProvider extends React.Component {

    constructor(props){
        super(props);
        const obj = {
            searchTerms:{},
            isLoading: true,
            results:{}
        };


        this.state = obj;
    }

    componentDidMount() {
        this.loadBookingConfig();
    }


    loadBookingConfig(){
        const apiPath = `${process.env.REACT_APP_API_URL}/bookingconfig`;
        this.setState({
            isLoading:true
        });
        axios.get(apiPath,{
            timeout: 300000,
            withCredentials:true
        }).then(res => {
            const newStateObj = {
                additionalDriverTypes:res.data.driverTypes,
                travelModes:res.data.travelModes,
                destinationTypes:res.data.destinationTypes,
                isLoading:false,
            };

            const destinationTypesMap = {};
            for(let i=0; i<res.data.destinationTypes.length; i+=1){
                destinationTypesMap[res.data.destinationTypes[i].flag] = res.data.destinationTypes[i];
            }

            const modeTypesMap = {};
            for(let i=0; i<res.data.travelModes.length; i+=1){
                modeTypesMap[res.data.travelModes[i].mode] = res.data.travelModes[i];
            }

            const driverTypesMap = {};
            for(let i=0; i<res.data.driverTypes.length; i+=1){
                driverTypesMap[res.data.driverTypes[i].id] = res.data.driverTypes[i];
            }

            newStateObj.destinationTypesMap = destinationTypesMap;
            newStateObj.travelModesMap = modeTypesMap;
            newStateObj.driverTypesMap = driverTypesMap;


            this.setState(newStateObj);

        }).catch(err => {
           // console.log('caught the error');
           cWarn(err);
        });
    }







    render(){
        return (
            <BookingConfigContext.Provider value={{
                ...this.state,
                setState: this.setState.bind(this),
            }}>
                {this.props.children}
            </BookingConfigContext.Provider>
        );
    }


}
export default BookingConfigContextProvider;